import React from 'react';

import styled from '@emotion/styled';

import { getInitials, truncateTextByCharacters } from '../../utils/utils';
import { ExternalLink } from '../Link/Link';

interface EducationCardProps {
  school: string;
  license: string;
  forApplicant?: boolean;
}

const EducationCard: React.FC<EducationCardProps> = ({
  school,
  license,
  forApplicant,
}) => {
  return (
    <Container>
      <Box>
        {' '}
        <AbbreviationIcon>{getInitials(school)}</AbbreviationIcon>
        <TextPart>
          <div className="name">
            {truncateTextByCharacters(`${school}`, 30)}
          </div>
          <div className="title">{truncateTextByCharacters(license, 10)}</div>
        </TextPart>
      </Box>
      {!forApplicant && (
        <Button href={license} target="_blank">
          View certificate
        </Button>
      )}
    </Container>
  );
};

export default EducationCard;

const Container = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

const TextPart = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.greyGrey2};

  & > * {
    word-break: break-all;
  }

  & > .name {
    color: ${({ theme }) => theme.palette.blackBlack3};
  }

  & > .title {
    font-size: 14px;
  }
`;

const AbbreviationIcon = styled.div`
  display: grid;
  place-content: center;
  width: 50px;
  height: 50px;
  color: white;
  background-color: ${({ theme }) => theme.palette.mainBlue};
  font-size: 18px;
  font-weight: 400;
  border-radius: 50%;
`;

const Button = styled(ExternalLink)`
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #2f80ed;
  text-wrap: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 480px) {
    padding-left: 52px;
  }
`;
const Box = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr;
  gap: 8px;
  width: 100%;
`;
